var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8346 5.79935L16.8346 5.85978C16.8346 6.57707 16.8346 6.93571 16.6619 7.22914C16.4892 7.52257 16.1757 7.69675 15.5487 8.04509L14.8876 8.41239C15.3432 6.87226 15.4952 5.21751 15.5514 3.80237C15.5538 3.7417 15.5565 3.68027 15.5592 3.6182L15.5611 3.57472C16.1039 3.7632 16.4086 3.90371 16.5987 4.16746C16.8346 4.49483 16.8346 4.92967 16.8346 5.79935Z",
    fill: "url(#paint0_linear_10875_11632)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.167969 5.79935L0.167971 5.85978C0.167991 6.57707 0.168001 6.93571 0.340658 7.22914C0.513315 7.52257 0.826827 7.69675 1.45384 8.04509L2.11531 8.41259C1.6597 6.8724 1.5077 5.21758 1.45151 3.80237C1.4491 3.7417 1.44639 3.68027 1.44365 3.6182L1.44172 3.57462C0.898808 3.76314 0.594015 3.90366 0.403883 4.16746C0.167935 4.49483 0.167946 4.92967 0.167969 5.79935Z",
    fill: "url(#paint1_linear_10875_11632)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50143 0.664062C9.98772 0.664062 11.2122 0.794969 12.1489 0.953014C13.0979 1.11312 13.5723 1.19318 13.9688 1.68142C14.3652 2.16967 14.3442 2.69738 14.3023 3.75279C14.1585 7.37611 13.3766 11.9018 9.1263 12.3021V15.2474H10.3181C10.7154 15.2474 11.0574 15.5278 11.1353 15.9173L11.293 16.7057H13.5013C13.8465 16.7057 14.1263 16.9855 14.1263 17.3307C14.1263 17.6759 13.8465 17.9557 13.5013 17.9557H3.5013C3.15612 17.9557 2.8763 17.6759 2.8763 17.3307C2.8763 16.9855 3.15612 16.7057 3.5013 16.7057H5.70964L5.86732 15.9173C5.94523 15.5278 6.28724 15.2474 6.68447 15.2474H7.8763V12.3021C3.62627 11.9016 2.84438 7.37604 2.70053 3.75279C2.65863 2.69738 2.63768 2.16967 3.03411 1.68142C3.43054 1.19318 3.90501 1.11312 4.85395 0.953014C5.79067 0.794969 7.01514 0.664062 8.50143 0.664062ZM9.29494 4.16312L9.21301 4.01616C8.89635 3.44809 8.73802 3.16406 8.5013 3.16406C8.26459 3.16406 8.10626 3.44809 7.78959 4.01616L7.70767 4.16312C7.61769 4.32454 7.57269 4.40526 7.50254 4.45851C7.43239 4.51177 7.34502 4.53154 7.17028 4.57107L7.01119 4.60707C6.39627 4.7462 6.08881 4.81577 6.01566 5.05099C5.94251 5.28622 6.15212 5.53133 6.57133 6.02154L6.67978 6.14837C6.79891 6.28767 6.85847 6.35732 6.88527 6.44349C6.91207 6.52966 6.90306 6.62259 6.88505 6.80845L6.86865 6.97766C6.80527 7.63171 6.77358 7.95874 6.96509 8.10412C7.1566 8.24949 7.44447 8.11695 8.02022 7.85185L8.16918 7.78327C8.33279 7.70794 8.41459 7.67027 8.5013 7.67027C8.58802 7.67027 8.66982 7.70794 8.83343 7.78327L8.98239 7.85185C9.55813 8.11695 9.84601 8.24949 10.0375 8.10412C10.229 7.95874 10.1973 7.63171 10.134 6.97766L10.1176 6.80845C10.0995 6.62259 10.0905 6.52966 10.1173 6.44349C10.1441 6.35732 10.2037 6.28767 10.3228 6.14837L10.4313 6.02154C10.8505 5.53133 11.0601 5.28622 10.9869 5.05099C10.9138 4.81577 10.6063 4.7462 9.99142 4.60707L9.83233 4.57107C9.65759 4.53154 9.57022 4.51177 9.50007 4.45851C9.42992 4.40526 9.38492 4.32455 9.29494 4.16312Z",
    fill: "url(#paint2_linear_10875_11632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10875_11632",
    x1: 8.50128,
    y1: 0.664062,
    x2: 8.50128,
    y2: 17.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#269812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10875_11632",
    x1: 8.50128,
    y1: 0.664062,
    x2: 8.50128,
    y2: 17.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#269812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10875_11632",
    x1: 8.50128,
    y1: 0.664062,
    x2: 8.50128,
    y2: 17.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#269812"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.3e8f24a15b9330096c83d0f2853d1fc3.svg";
export { ForwardRef as ReactComponent };